import { render } from "./subMenuReceber.vue?vue&type=template&id=446dfbd0"
import script from "./subMenuReceber.vue?vue&type=script&lang=js"
export * from "./subMenuReceber.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__